import React from 'react';
import KYCBaseContainer from 'apex-web/lib/components/KYC';
import KYCLevelsContainer from './KYCLevelsContainer';

const KYCComponent = () => {
  return <KYCBaseContainer LevelsComponent={KYCLevelsContainer} />;
};

export default KYCComponent;
